module.exports = __webpack_public_path__ + "static/media/kp.fca0703d.svg";